// Regiao de Estudo
import api from '@/api';
import axios from 'axios';
import _ from 'lodash';
import moment from 'moment';
import { debug } from 'util';



export default function (data) {

  var STATE = {
    eventInfo: {},
    products:{},
    productDiscountsRules:[],
    memberDiscountsRules:[],
    teamDiscountsRules:[],
    status: 'loading',
    statusError: {},
  }

  return {
    namespaced: true,
    state: STATE,

    mutations: {
      setState: function (state, obj) {
          for(var k in obj){
            state[k] = obj[k]
          }
      },
    },
  

    actions: {
    
      loadEvent: async function (ctx, id) {
       
        ctx.commit( 'setState', {...STATE} )
        
        api.getJSON('eventProduct', id )
        .then(data => {
            ctx.commit('setState',{ 
                            products: _.keyBy(data.data.products,'id'), 
                            productDiscountsRules: data.data.discounts, 
                            memberDiscountsRules: data.data.memberDiscounts, 
                            teamDiscountsRules: data.data.teamDiscounts, 
                            eventInfo: data.data.eventInfo,
                            status:'loaded'
                        })
        }).catch(data => {
            console.log("Deu Erro na requisicao %o", data)
            
            ctx.commit('setState',{status:'error',statusError: _.get(data,'response.data.error.message',data.message) } )
        })

      },
    
    },


    getters: {

      eventInfo: state => state.eventInfo,
      status: state => state.status, 
      statusError: state => state.statusError, 
      getProductById: state => productId => {
          return {...state.products[productId]} || false
      },
      memberDiscountsRules: state => state.memberDiscountsRules,
      teamDiscountsRules: state => state.teamDiscountsRules,
      productDiscountsRules: state => state.productDiscountsRules,

      paymentOptions: state => (_.map(state.eventInfo.paymentOptions, po=>{
                  po.paymentProviderId = po.paymentProviderOption.paymentProviderId;
                  return po
      }) || [])

    }

  }
}
